<template>
  <div class="WisdomSiteContainer">
    <Row justify="center" type="flex">
      <Col span="24">
        <!-- Banner外层相对定位 -->
        <div class="banner-box">
          <img
            class="banner-img"
            src="../../static/img/banner/news.png"
            alt="新闻banner"
          />
          <div class="banner-font-wrap">
            <div class="banner_font1">新闻中心</div>
            <div class="banner_font2"></div>
            <div class="banner_font3">了解最新企业动态</div>
          </div>
        </div>
      </Col>
      <!-- 修正栅格，大屏15，移动端铺满 -->
      <Col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
        <div class="router-wrap">
          <router-view></router-view>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  created() {
    // 页面进入置顶
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.banner-box {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.banner-img {
  width: 100%;
  height: 485px;
  object-fit: cover;
}
.banner-font-wrap {
  position: absolute;
  left: 25%;
  top: 50%;
  transform: translateY(-50%);
  color: #ffffff;
}
.banner_font1 {
  font-size: 30px;
  font-family: lianmengqiyilushuaizhengruiheiti;
  font-weight: 400;
}
.banner_font2 {
  width: 120px;
  height: 2px;
  background-color: #fff;
  margin-top: 16px;
}
.banner_font3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  margin-top: 16px;
  opacity: 0.9;
}
.router-wrap {
  margin: 60px 30px;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .banner-img {
    height: 240px;
  }
  .banner-font-wrap {
    left: 8%;
  }
  .banner_font1 {
    font-size: 22px;
  }
  .banner_font3 {
    font-size: 14px;
  }
  .router-wrap {
    margin: 30px 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue